// @ts-nocheck
export default defineNuxtPlugin(() => {
  const rootStore = useRootStore()

  return {
    provide: {
      lang: rootStore.lang
    }
  }
})
